import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import {
  changePrimaryJotr,
  changeWhdJotr
} from 'actions';

import CustomerJotrCard from 'components/Customer/CustomerJotrCard';
import ModalWrapper from 'components/Modals/ModalWrapper';
import ConfirmModal from 'components/Modals/ConfirmModal';

const CustomerJotrsModal = ({
  title,
  isShown,
  onConfirm,
  jotrs,
  cardClassName,
  showActions
}) => {
  const dispatch = useDispatch();
  const [confirmPrimaryShown, setConfirmPrimaryShown] = useState(false);
  const [confirmWhdShown, setConfirmWhdShown] = useState(false);
  const [selectedJotr, setSelectedJotr] = useState(null);

  const jurisdictions = useSelector(state => state.common?.jurisdictions ?? []);
  const isChangingPrimaryJotr = useSelector(state => state.customer.isChangingPrimaryJotr);
  const isChangingWhdJotr = useSelector(state => state.customer.isChangingWhdJotr);

  const openPrimaryModal = (jotr) => {
    setConfirmPrimaryShown(true);
    setSelectedJotr(jotr);
  };

  const closePrimaryModal = () => {
    setConfirmPrimaryShown(false);
    setSelectedJotr(null);
  };

  const onConfirmPrimaryJotr = () => {
    dispatch(changePrimaryJotr(selectedJotr.customerId, selectedJotr.id));
    setConfirmPrimaryShown(false);
    setSelectedJotr(null);
  };

  const openWhdModal = (jotr) => {
    setConfirmWhdShown(true);
    setSelectedJotr(jotr);
  };

  const closeWhdModal = () => {
    setConfirmWhdShown(false);
    setSelectedJotr(null);
  };

  const onConfirmWhdJotr = () => {
    dispatch(changeWhdJotr(selectedJotr.customerId, selectedJotr.id));
    setConfirmWhdShown(false);
    setSelectedJotr(null);
  };

  return (<ModalWrapper
    modalSize="customer-jotrs-modal"
    headerClose={ false }
    isOpen={ isShown }
    title={ title }
    btnConfirmTitle="Close"
    showCancel={ false }
    onConfirm={ () => onConfirm() }
  >
    { (!jotrs || jotrs.length === 0) && <p>No Tax Residencies</p> }
    { jotrs.length > 0 && <div className="customer-jotrs">
      { jotrs.filter(x => x.source === 2).length > 0 && <div className="columns">
        <p className="column col-12"><strong>From Forms:</strong></p>
        { jotrs.filter(x => x.source === 2).map(x => <div className="column col-6" key={ `${ x.customerId }${ x.source }${ x.countryIsoCode }` }>
          <CustomerJotrCard
            className={ cardClassName }
            jotr={ x }
            jurisdictions={ jurisdictions }
            showActions={ showActions }
            onMakePrimary={ jotr => openPrimaryModal(jotr) }
            onMakeWhd={ jotr => openWhdModal(jotr) }
          />
        </div>)}
      </div> }
      { jotrs.filter(x => x.source === 1).length > 0 && <div className="columns">
        <p className="column col-12"><strong>From Books & Records:</strong></p>
        { jotrs.filter(x => x.source === 1).map(x => <div className="column col-6" key={ `${ x.customerId }${ x.source }${ x.countryIsoCode }` }>
          <CustomerJotrCard
            className={ cardClassName }
            jotr={ x }
            jurisdictions={ jurisdictions }
            showActions={ showActions }
            onMakePrimary={ jotr => openPrimaryModal(jotr) }
            onMakeWhd={ jotr => openWhdModal(jotr) }
          />
        </div>)}
      </div> }
      { showActions && <ConfirmModal
        key="switchPrimaryJotr"
        isShown={ confirmPrimaryShown }
        isPerformingAction={ isChangingPrimaryJotr }
        onConfirm={ () => onConfirmPrimaryJotr() }
        onCancel={ () => closePrimaryModal() }
        title="Switch Primary Tax Residence"
        message="Are you sure you want to switch the Primary Tax Residence?"
      >
        <p>The Primary Tax Residence is used for US Indicia and Presumption Rules.</p>
      </ConfirmModal> }
      { showActions && <ConfirmModal
        key="switchWhdJotr"
        isShown={ confirmWhdShown }
        isPerformingAction={ isChangingWhdJotr }
        onConfirm={ () => onConfirmWhdJotr() }
        onCancel={ () => closeWhdModal() }
        title="Switch the WHD Tax Residence"
        message="Are you sure you want to switch the Tax Residence that is used for withholding calculations?"
      /> }
    </div>}
  </ModalWrapper>);
};

CustomerJotrsModal.propTypes = {
  title: PropTypes.string,
  isShown: PropTypes.bool,
  onConfirm: PropTypes.func,
  jotrs: PropTypes.arrayOf(PropTypes.shape),
  cardClassName: PropTypes.string,
  showActions: PropTypes.bool
};

CustomerJotrsModal.defaultProps = {
  title: 'Tax Residencies',
  isShown: false,
  onConfirm: () => {},
  jotrs: null,
  cardClassName: null,
  showActions: false
};

export default CustomerJotrsModal;
